import type { CSSProperties } from 'react';
import { FiCheck as Check, FiPackage as PackageOpen } from 'react-icons/fi';
import { THEME_PRIMARY, ui } from '../constants';

interface NoPlanOptionProps {
  selected: boolean;
  onSelect: () => void;
}

function NoPlanOption({ selected, onSelect }: NoPlanOptionProps) {
  return (
    <button
      type="button"
      className={`plan-card no-plan-card rounded-4 bg-white dark__bg-card-dark ${selected ? 'selected' : ''}`}
      style={{ '--plan-color': THEME_PRIMARY } as CSSProperties}
      onClick={onSelect}
      aria-pressed={selected}
    >
      <span className="card-check rounded-circle">
        {selected ? <Check size={16} strokeWidth={3} /> : null}
      </span>
      <span className="logo-shell rounded-4">
        <PackageOpen size={28} />
      </span>
      <span className="plan-copy">
        <strong className="text-1000">{ui.noPlanOption.title}</strong>
        <small className="text-secondary fs--2">{ui.noPlanOption.description}</small>
      </span>
      <span className="choose-label fs--2">
        {selected ? ui.common.selected : ui.common.selectPlan}
      </span>
    </button>
  );
}

export default NoPlanOption;
